import { defineStore } from 'pinia'
import { store } from '../index'

export const useCommonStore = defineStore({
  id: 'Common',
  state: () => ({
    loginPageSetting: null as any,
    portalPageSetting: null as any,
    serviceSetting: {}
  }),
  getters: {
    getServiceSettings(): any {
      return this.serviceSetting
    }
  },
  actions: {
    setLoginPageSetting(payload: any) {
      console.log('setLoginPageSetting:', payload)
      this.loginPageSetting = payload
    },
    setPortalPageSetting(payload: any) {
      console.log('setPortalPageSetting:', payload)
      this.portalPageSetting = payload
    },
    setServiceSetting(payload: any) {
      console.log('setServiceSetting:', payload)
      this.serviceSetting[payload.service_type] = payload
    },
    delServiceSetting(payload: any) {
      console.log('delServiceSetting:', payload)
      delete this.serviceSetting[payload]
    }
  }
})

export const useCommonStoreWithOut = () => {
  return useCommonStore(store)
}
